/** Adidas cart page: 1344px content + 64px left / 32px right padding inside 1440px box */
export const CART_PAGE_SHELL =
  "mx-auto box-border w-full max-w-[1440px] px-4 py-8 sm:px-10 lg:pl-[64px] lg:pr-8 lg:py-10"

/** Adidas wishlist page: 1480px content + 60px horizontal padding inside 1600px box */
export const WISHLIST_PAGE_SHELL =
  "mx-auto box-border w-full max-w-[1600px] px-4 py-8 sm:px-10 lg:px-[60px] lg:py-10"

export const CART_TITLE_CLASS =
  "text-[32px] font-bold uppercase leading-none tracking-tight text-foreground sm:text-[46px]"

export const CART_TITLE_COUNT_CLASS =
  "text-xl font-normal normal-case sm:text-2xl"

export const COMMERCE_SECTION_TITLE_CLASS =
  "mb-0 text-[28px] font-bold uppercase leading-none tracking-tight text-foreground sm:text-[38px]"

export const CHECKOUT_STEP_TITLE_CLASS =
  "text-xl font-bold uppercase tracking-tight text-foreground sm:text-2xl"
